import { useMutation } from "@tanstack/react-query";
import { sendAdminInvite } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export function useAdminInvite() {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  //user?.client_tenancy_info?.platform_client_id
  return useMutation({
    mutationFn: async (payload) => sendAdminInvite(id, payload),
  });
}
